import {useConfig} from '@aboutyou/config';
import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {useTranslation} from '@aboutyou/i18n';

export const useOutletLinkConfig = (
  campaignName: 'metabar_desktop' | 'catNav_mWeb',
) => {
  const {isActive: showOutletLink} = useIsFeatureActive('show_outlet_link');
  const {t} = useTranslation();
  const {ayOutletUrl: baseAyOutletUrl} = useConfig();
  const outletLabel = t('Outlet');

  let ayOutletUrlWithUtmParams = '';

  if (baseAyOutletUrl) {
    const ayOutletUrl = new URL(baseAyOutletUrl);
    ayOutletUrl.searchParams.set('utm_source', 'aboutyou');
    ayOutletUrl.searchParams.set('utm_medium', 'shop');
    ayOutletUrl.searchParams.set('utm_campaign', campaignName);
    ayOutletUrlWithUtmParams = ayOutletUrl.toString();
  }

  return {
    outletLabel,
    ayOutletUrl: ayOutletUrlWithUtmParams,
    showOutletLink,
  };
};
